export default __webpack_public_path__ + "static/media/settings-icon-gray.d8baf541.svg";